import React from "react";
import { CircularProgress, Backdrop } from "@mui/material";

function Spinner() {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
        >
            <CircularProgress size={60} thickness={3} sx={{ color: "#4B4D4F" }} />
        </Backdrop>

    );
};

export default Spinner;
